module.exports = __webpack_public_path__ + "static/media/about-bg.4c3f1bdb.png";